<script setup lang="ts">
import CapabilityContent from "~/components/molecules/CapabilityContent.vue";
</script>

<template>
  <CapabilityContent />
</template>
